import React from 'react';
import '../styles/startGameOverlay.css';
import { useTranslation } from 'react-i18next';

/**
 * Модальное окно ошибки авторизации поверх заставки.
 * Показывает сообщение об ошибке и кнопку повторного подключения.
 */
const AuthErrorModal = ({ onRetry }) => {
  const { t } = useTranslation();
  return (
    <div className="auth-error-overlay">
      <div className="auth-error-modal">
        <p className="auth-error-modal__title">{t('auth.error_title', 'Connection Error')}</p>
        <p className="auth-error-modal__message">
          {t('auth.error_text', 'Failed to connect to the server. Please check your connection and try again.')}
        </p>
        <button className="auth-error-modal__button" onClick={onRetry}>
          {t('auth.reconnect', 'Reconnect')}
        </button>
      </div>
    </div>
  );
};

export default AuthErrorModal;
